import { createActionGroup, emptyProps, props } from '@ngrx/store';

export type LoginBrowserFailedReason =
  | 'browser-open-failed'
  | 'invalid-url'
  | 'unknown';

export const MobileAuthActions = createActionGroup({
  source: 'mobile-auth',
  events: {
    'Login Browser Failed': props<{
      reason: LoginBrowserFailedReason;
      urlLength?: number;
    }>(),
    // NOTE: Dispatched as soon as the Auth0 deep link (callback URL) arrives.
    // This is a positive signal that the browser step succeeded and the
    // post-login pipeline (handleRedirectCallback → forkJoin → biometrics →
    // LogIn) is in progress. Consumers (e.g. MobileAuthorizeComponent) use
    // this to cancel the "delayed" / "recovery" state timers so the user
    // keeps seeing the spinner instead of the retry UI while the pipeline
    // finishes.
    'Login Callback Received': emptyProps(),
    'Reset Session Requested': emptyProps(),
  },
});
